export default __webpack_public_path__ + "static/media/process_08.32a54e89.png";